import { memo, useEffect, useRef } from 'react'
import { PlinkoBets, PlinkoBallsSelector } from '../organisms/PlinkoBets'
import { PlinkoForm } from '../organisms/PlinkoForm'
import { Box, Grid } from '@chakra-ui/react'

import { Image as ImageHOC } from '@/components/HOC/Image'
import GameBg from '@/public/assets/images/plinko/bg3.png'
import { useLocalStorage } from 'usehooks-ts'
import { LocalStorageKey } from '@/constants/localstorage'
import { useBalanceStore } from '@/context/UserBalance'
import { PlinkoState, usePlinkoStore } from '@/context/PlinkoProvider'
import { PlinkoLastGames } from '../PlinkoLastGames'
import { PlinkoBanner } from '../molecules/ContestBanner'

export const PlinkoTemplate = memo(() => {
  const gameRef = useRef<HTMLIFrameElement | null>(null)

  const [isSoundEnabled] = useLocalStorage(LocalStorageKey.Audio, true)

  useEffect(() => {
    if (!gameRef.current?.contentWindow) return
    ;(gameRef.current.contentWindow as any).postMessage(
      {
        type: 'sound',
        value: isSoundEnabled,
      },
      '*'
    )
  }, [isSoundEnabled])

  useEffect(() => {
    if (!gameRef.current?.contentWindow) return
    gameRef.current.contentWindow.location = 'https://game.blaze.ninja/plinko'
  }, [])

  useEffect(() => {
    const handle = async (event: any) => {
      if (event.origin !== 'https://game.blaze.ninja') {
        return
      }

      const data = event.data
      if (data.event == 'plinko:game-loaded') {
        await new Promise((resolve) => setTimeout(resolve, 250))
        gameRef.current?.style.setProperty('opacity', '0.3')
        await new Promise((resolve) => setTimeout(resolve, 200))
        gameRef.current?.style.setProperty('opacity', '0.6')
        await new Promise((resolve) => setTimeout(resolve, 200))
        gameRef.current?.style.setProperty('opacity', '1')
        usePlinkoStore.setState({
          state: PlinkoState.READY,
        })

        gameRef?.current?.contentWindow?.postMessage(
          {
            type: 'sound',

            value: isSoundEnabled,
          },
          '*'
        )
      }

      if (data.event == 'plinko:game-started') {
        useBalanceStore.getState().lockBalance()
        usePlinkoStore.setState({
          state: PlinkoState.GAMING,
        })
        return
      }

      if (data.event == 'plinko:removeBall') {
        return
      }

      if (data.event == 'plinko:game-finished') {
        useBalanceStore.getState().unLockBalance()
        usePlinkoStore.setState({
          state: PlinkoState.READY,
        })
        return
      }
    }

    window.addEventListener('message', handle, true)

    return () => {
      window.removeEventListener('message', handle)
    }
  }, [])

  return (
    <>
      {/* <PlinkoBanner /> */}
      <Grid gridTemplateColumns={{ base: '1fr', xl: 'auto 320px' }} gap={5}>
        <Box>
          <Box
            background={'black'}
            height={[350, 650]}
            p={{ base: 0, md: 5 }}
            rounded={'2xl'}
            pos={'relative'}
            overflow={'hidden'}
          >
            <ImageHOC
              fill={'auto'}
              quality={90}
              objectFit="fill"
              priority={true}
              loading="eager"
              src={GameBg}
              alt={''}
              zIndex={10}
            />
            <iframe
              ref={gameRef}
              id="game"
              sandbox="allow-scripts allow-same-origin"
              key="iframe"
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
                display: 'block',
                transform: 'translateZ(0)',
                backfaceVisibility: 'hidden',
                WebkitTransform: 'translate3d(0, 0, 0)',
                willChange: 'transform',
                zIndex: 20,
                opacity: 0.01,
                position: 'relative',
              }}
              title="Plinko Game"
            />
          </Box>
          <Box pos={'relative'} zIndex={10}>
            <Box mt={4}>
              <PlinkoControlPanel />
            </Box>
          </Box>
        </Box>

        <PlinkoLastGames />
      </Grid>
    </>
  )
})

const PlinkoControlPanel = () => {
  return (
    <>
      <PlinkoBallsSelector />
      <PlinkoForm />
      <PlinkoBets />
    </>
  )
}
